/**
 * @generated SignedSource<<84a7a156b510ae30b24066e9854c13de>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "folderId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "InboxFolderThreadsRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "folderId",
                "variableName": "folderId"
              }
            ],
            "kind": "FragmentSpread",
            "name": "Inbox_folderThreadsViewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "InboxFolderThreadsRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 1
                  },
                  {
                    "items": [
                      {
                        "kind": "Variable",
                        "name": "folderIds.0",
                        "variableName": "folderId"
                      }
                    ],
                    "kind": "ListValue",
                    "name": "folderIds"
                  }
                ],
                "concreteType": "ThreadConnection",
                "kind": "LinkedField",
                "name": "threads",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "totalCount",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "UserScope",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "3b495f3cb5ae9f5a577878f39259472e",
    "id": null,
    "metadata": {},
    "name": "InboxFolderThreadsRefetchQuery",
    "operationKind": "query",
    "text": "query InboxFolderThreadsRefetchQuery(\n  $folderId: ID\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ...Inbox_folderThreadsViewer_anm0i\n    id\n  }\n}\n\nfragment Inbox_folderThreadsViewer_anm0i on UserScope {\n  threads(folderIds: [$folderId], first: 1) {\n    pageInfo {\n      totalCount\n    }\n  }\n  id\n}\n"
  }
};
})();

node.hash = "f5200df9f0f7f8c4c2ebc4eeb8444fb2";

module.exports = node;
